var BOG_GAME_NAMES = {
    PASCAL: 'PASCAL',
    FISHING: 'FISHING',
    CATCH_ME: 'CATCH_ME',
    TOUCH_ME: 'TOUCH_ME',
    FIGHTERS: 'FIGHTERS',
};

export { BOG_GAME_NAMES };
